import Vue from 'vue';

export default function() {

    // Core
    Vue.filter('bool', require('js-core/js/filters/bool').default);
    Vue.filter('concat', require('js-core/js/filters/concat').default);
    Vue.filter('date', require('js-core/js/filters/date').default);
    Vue.filter('empty', require('js-core/js/filters/empty').default);
    Vue.filter('number', require('js-core/js/filters/number').default);
    Vue.filter('truncate', require('js-core/js/filters/truncate').default);
    Vue.filter('ucFirst', require('js-core/js/filters/ucFirst').default);
    Vue.filter('upperCase', require('js-core/js/filters/upperCase').default);

    // App
    Vue.filter('userRole', require('common/filters/userRole').default);
    Vue.filter('actionTypeTitle', require('common/filters/actionTypeTitle').default);
    Vue.filter('seedType', require('common/filters/seedType').default);
    Vue.filter('parcel', require('common/filters/parcel').default);
    Vue.filter('originType', require('common/filters/originType').default);
    Vue.filter('quantityUnitValue', require('common/filters/quantityUnitValue').default);
    Vue.filter('waterInsightsSeriesTitle', require('common/filters/waterInsightsSeriesTitle').default);
}
